import React from 'react';
import CustomerError from '../../../components/CustomerError';
import {UserCategory, UserGender, UserGrade, UserType} from '../../../hooks/apis/useUser';
import {Button, Card, Space, Table} from 'antd';
import UseKnowledgeTest, {IKnowledgeTestQueryHistoryResponseItem, KnowledgeTestType} from '../../../hooks/apis/useKnowledgeTest';
import moment from 'moment';
import {useParams} from 'react-router-dom';
import useAuth from '../../../utils/AuthContext';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useMount} from 'react-use';

export default function ManageKnowledgeTestExportPage() {
  const auth = useAuth();
  const queryByIdState = UseKnowledgeTest.queryById();
  const listState = UseKnowledgeTest.exportReport();
  const params = useParams() as {id?: string};
  const routeQueryId = params?.id || '';

  function refresh() {
    queryByIdState
      .request({
        id: parseInt(routeQueryId),
      })
      .then(res => {
        listState
          .request({testId: res.id})
          .then()
          .catch(CommonApiErrorHandler);
      });
  }

  useMount(() => {
    refresh();
  });

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      {queryByIdState.data && (
        <Card
          title={queryByIdState.data.contest.name + KnowledgeTestType[queryByIdState.data.type] + ' 统计数据'}
          extra={
            <Space>
              <Button onClick={refresh}>刷新</Button>
              {listState.data && (
                <Button
                  onClick={() => {
                    window.open(listState.data?.url, '_blank');
                  }}>
                  下载 Excel
                </Button>
              )}
            </Space>
          }>
          {listState.data && (
            <Table<IKnowledgeTestQueryHistoryResponseItem>
              loading={listState.loading}
              rowKey={'submitterId'}
              dataSource={listState.data.list}
              bordered
              size={'small'}
              scroll={{x: 1300 + (queryByIdState.data.type === KnowledgeTestType.正式答题 ? 200 : 0)}}>
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'序号'} render={(_, _i, index) => index + 1} fixed width={60} />
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'姓名'} render={(_, item) => item.submitter.legalName} fixed width={80} />
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'性别'} render={(_, item) => UserGender[item.submitter.gender]} width={60} />
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem>
                title={'出生日期'}
                render={(_, item) => moment(item.submitter.birthDate).format('YYYY-MM-DD')}
                width={110}
              />
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'组别'} render={(_, item) => UserCategory[item.submitter.category]} width={70} />
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'学校'} render={(_, item) => item.submitter.schoolName} />
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'年级'} render={(_, item) => UserGrade[item.submitter.grade]} width={70} />
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'班级'} render={(_, item) => item.submitter.classNo + '班'} width={70} />
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'指导老师姓名'} render={(_, item) => item.submitter.coachName} />
              <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'联系电话'} render={(_, item) => item.submitter.telephone} width={130} />
              {queryByIdState.data.type === KnowledgeTestType.答题演练 && (
                <React.Fragment>
                  <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'答题次数'} render={(_, item) => item.count} width={70} />
                  <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'答题平均分'} render={(_, item) => item.averageScoreGet} width={70} />
                  <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'单次最高分'} render={(_, item) => item.bestScoreGet} width={70} />
                </React.Fragment>
              )}
              {queryByIdState.data.type === KnowledgeTestType.正式答题 && (
                <React.Fragment>
                  <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'得分'} render={(_, item) => item.bestScoreGet} width={70} />
                  <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'开始时间'} render={(_, item) => item.beginTime} width={180} />
                  <Table.Column<IKnowledgeTestQueryHistoryResponseItem> title={'交卷时间'} render={(_, item) => item.submittedTime} width={180} />
                </React.Fragment>
              )}
            </Table>
          )}
        </Card>
      )}
    </div>
  );
}
